import SkuHistorySearch from "@/classes/stock/SkuHistorySearch";
import SkuHistorySearchPillCollection from "@/classes/stock/SkuHistorySearchPillCollection";
import GridColumn from "@/classes/component-classes/GridColumn";

export default class SkuHistory {
    constructor() {

        this.searchPills = new SkuHistorySearchPillCollection();
        this.searchCriteria = new SkuHistorySearch();
        this.selectedSkuName = '';
        this.selectedSkuComposite = '';
        this.skuCompositeGridData = [];
        this.hideExcelDownloadBusy = true;
        this.skuGroups = [];
        this.isSearchData = false;

        this.skuNames = [];
        this.skuComposites = [];

        this. skuCompositeGridCols = [

               new GridColumn('1', 'Warehouse', 'warehouse', '170', true, false),
            new GridColumn('2', 'Location', 'location', '100', true, false),
            new GridColumn('3', 'WH Ref', 'whRef', '120', true, false),
            new GridColumn('4', 'Shipment No.', 'shipmentNumber', '100', true, false),
            new GridColumn('5', 'Quantity', 'quantity', '50', true, false, 'rowColor'),
            new GridColumn('6', 'Date & Time', 'dateTime', '110', true, false),
            new GridColumn('7', 'Location Stock', 'locationStock', '90', true, false),
            new GridColumn('8', 'Total Stock', 'totalStock', '70', true, false),
            new GridColumn('9', 'Cust Ref', 'custRef', '160', true, false),
            new GridColumn('10', 'Curr', 'currency', '50', false, false),
            new GridColumn('11', 'Value', 'value', '50', false, false),

        ]

    }

}
